// extracted by mini-css-extract-plugin
module.exports = {"headerBase":"PictureBox_headerBase__1YPJz","linksBase":"PictureBox_linksBase__fl4Pr","displayFlex":"PictureBox_displayFlex__3sk2z","listsBase":"PictureBox_listsBase__jYfOR"};